module.exports = __webpack_public_path__ + "media/wolf_howling.a4371034.mp3";